import {
  PRIMARY_50,
  PRIMARY_600,
  WARNING_50,
  WARNING_600,
  SUCCESS_50,
  SUCCESS_600,
  ERROR_50,
  ERROR_600,
  GRAY_100,
  GRAY_700,
  AI_25,
  AI_500
} from "../constant/colors";
import { fontWeights, sizes } from "../constant/styles";

/**
 * Standard patient status color mappings based on Figma Tag Status Mapping
 * Used for patient table cells and bulk action dropdowns
 */
export const PATIENT_STATUS_COLORS = {
  New: { background: PRIMARY_50, color: PRIMARY_600 },
  "In Progress": { background: WARNING_50, color: WARNING_600 },
  "Follow Up": { background: WARNING_50, color: WARNING_600 },
  "Awaiting Assistance": { background: PRIMARY_50, color: PRIMARY_600 },
  "OOP Met": { background: AI_25, color: AI_500 },
  Established: { background: SUCCESS_50, color: SUCCESS_600 },
  Done: { background: SUCCESS_50, color: SUCCESS_600 }
};

/**
 * Enrollment status color mappings based on Figma designs
 * Used for enrollment table cells and bulk action dropdowns
 */
export const ENROLLMENT_STATUS_COLORS = {
  Prepare: { background: PRIMARY_50, color: PRIMARY_600 },
  Applied: { background: WARNING_50, color: WARNING_600 },
  "Applied To Waitlist": { background: WARNING_50, color: WARNING_600 },
  Approved: { background: SUCCESS_50, color: SUCCESS_600 },
  Expired: { background: ERROR_50, color: ERROR_600 },
  Exhausted: { background: GRAY_100, color: GRAY_700 },
  Canceled: { background: ERROR_50, color: ERROR_600 },
  Denied: { background: ERROR_50, color: ERROR_600 },
  Ineligible: { background: GRAY_100, color: GRAY_700 },
  "Not Interested": { background: GRAY_100, color: GRAY_700 },
  "Not Returned": { background: AI_25, color: AI_500 },
  "Missing Information": { background: WARNING_50, color: WARNING_600 },
  "Temporarily Approved": { background: PRIMARY_50, color: PRIMARY_600 }
};

/**
 * Default colors for non-standard statuses (gray)
 */
export const DEFAULT_STATUS_COLORS = { background: GRAY_100, color: GRAY_700 };

/**
 * Get status tag colors for a given status text
 * @param {string} statusText - The status text to get colors for
 * @param {object} colorMap - Optional custom color map (defaults to PATIENT_STATUS_COLORS)
 * @returns {object} Object with background and color properties
 */
export const getStatusTagColors = (statusText, colorMap = PATIENT_STATUS_COLORS) => {
  if (colorMap[statusText]) {
    return colorMap[statusText];
  }
  const normalizedKey = Object.keys(colorMap).find((key) => key.toLowerCase() === statusText?.toLowerCase());
  return normalizedKey ? colorMap[normalizedKey] : DEFAULT_STATUS_COLORS;
};

/**
 * Get inline styles for a status tag
 * @param {string} statusText - The status text to style
 * @param {object} colorMap - Optional custom color map
 * @returns {object} React inline style object
 */
export const getStatusTagStyle = (statusText, colorMap = PATIENT_STATUS_COLORS) => {
  const colors = getStatusTagColors(statusText, colorMap);
  return {
    background: colors.background,
    color: colors.color,
    borderRadius: "24px",
    fontWeight: fontWeights.bold,
    fontSize: sizes.small,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "4px 8px",
    textTransform: "uppercase",
    lineHeight: 1
  };
};
